const BASE_URL = "/api/preschool";
//const BASE_URL = "http://localhost:9093/api/preschool";

const request = async (endpoint, options = {}) => {
  // Reads JWT token from sessionStorage
  const token = sessionStorage.getItem("token"); 
  
  const headers = {
    // Automatically attaches token to ALL requests
    ...(token && { "Authorization": `Bearer ${token}` }),
    ...options.headers,
  };

  // Only set 'Content-Type' if the body is NOT FormData.
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
  }

  const config = {
    ...options,
    headers,
  };

  const url = `${BASE_URL.replace(/\/$/, "")}/${endpoint.replace(/^\//, "")}`;

  const response = await fetch(url, config);

  if (response.status === 401) {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("roleId");
    sessionStorage.removeItem("clientName");
    sessionStorage.removeItem("clientId");
    window.location.href = "/login";
    throw new Error("Session expired. Please log in again.");
  }

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const apiService = {
  // ── Authentication & Auth ──
  login: (credentials) => request("/auth/login", { 
    method: "POST", 
    body: JSON.stringify(credentials) 
  }),

  logout: () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("roleId");
    sessionStorage.removeItem("clientName");
    sessionStorage.removeItem("clientId");
    window.location.href = "/login";
  },

  getCurrentUserToken: () => sessionStorage.getItem("token"),
  isAuthenticated: () => !!sessionStorage.getItem("token")
};